import { z } from 'zod';

export const DocumentSearchToolName = 'documentSearch';

/**
 * DocumentSearch tool definition
 */
export const documentSearchArgsSchema = z.object({
  searchQuery: z
    .string()
    .describe(
      'Complete search query or user question. Use natural language - the system handles both semantic and keyword matching internally',
    ),
  context: z
    .string()
    .nullable()
    .describe(
      'Additional context from conversation or previous tool results to improve search accuracy',
    ),
});

export const documentSearchContentSchema = z.string();

export type DocumentSearchArgs = z.infer<typeof documentSearchArgsSchema>;
export type DocumentSearchContent = z.infer<typeof documentSearchContentSchema>;
